module.exports = __webpack_public_path__ + "static/media/undraw_High_five_u364.09f9ff8c.svg";